export { default } from "ember-router-helpers/helpers/is-active.js";
